interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-3xl text-center" : "max-w-2xl"}>
      <p className="mb-3 flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.28em] text-primary-600">
        <span className={`h-px w-6 bg-primary-500 ${isCenter ? "hidden" : ""}`} />
        {eyebrow}
      </p>
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {description ? (
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          {description}
        </p>
      ) : null}
    </div>
  );
}